import React, { createContext, useContext, ReactNode, useReducer, Dispatch, useMemo } from 'react';

import { reducer, State, Action } from './searchReducer';

type Props = {
  children: ReactNode;
};

const initialProps: State = {
  isSearching: false,
  isLoading: true,
  hasErrored: false,
  searchTotal: 0,
  searchPage: 1,
  results: [],
  searchText: '',
};

const SearchStateContext = createContext(initialProps);

const SearchDispatchContext = createContext<Dispatch<Action>>(() => {
  throw new Error('Not implemented. Must be inside of provider.');
});

export default function SearchContextProvider({ children }: Props) {
  const [state, dispatch] = useReducer(reducer, initialProps);
  const value = useMemo(() => {
    return { state, dispatch };
  }, [state, dispatch]);
  return (
    <SearchStateContext.Provider value={value.state}>
      <SearchDispatchContext.Provider value={value.dispatch}>
        {children}
      </SearchDispatchContext.Provider>
    </SearchStateContext.Provider>
  );
}

export function useSearchState() {
  return useContext(SearchStateContext);
}

export function useSearchDispatch() {
  return useContext(SearchDispatchContext);
}
